import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { formatPrice, formatURL } from '../../../utils';
import { openModalQuotationDateWarning } from '../../../actions/coverageActions';

class BottomBar extends Component {
  constructor(props) {
    super(props);
    this.purchasePlan = this.purchasePlan.bind(this);
  }

  purchasePlan() {
    const location = {
      pathname: formatURL(
        this.props.match.params,
        `/pedido/${this.props.match.params.product_code}/${this.props.match.params.destination}/${this.props.match.params.begin_date}/${this.props.match.params.end_date}/`
      ),
    };

    this.props.history.push(location);
  }

  render() {
    if (!this.props.plans[0]) return <div />;

    const plan = this.props.plans[0];

    return (
      <div className="purchase-mobile">
        <div className="component ">
          <div className="purchase-fixed">
            <div className="section-price">
              <p className="real-price">
                <strong>
                  {plan.price_with_coupon_discount ? (
                    <span>R$ {formatPrice(plan.price_with_coupon_discount || plan.adult.price)}</span>
                  ) : (
                    <span>R$ {formatPrice(plan.adult && plan.adult.price)}</span>
                  )}
                </strong>
                <span> 12x sem juros</span>
              </p>
              <p className="price-pix">
                <strong>
                  {plan.price_with_coupon_discount ? (
                    <span>
                      R$ {formatPrice(plan.price_with_coupon_discount - 0.05 * plan.price_with_coupon_discount)}
                    </span>
                  ) : (
                    <span>R$ {plan.adult && formatPrice(plan.adult.price - (0.05 * plan.adult.price).toFixed(2))}</span>
                  )}
                </strong>
                <img src="/assets/images/icons/pixDiscountFlag.svg" alt="pix flag" />
              </p>
              <p className="real-price">/preço por pessoa</p>
            </div>
            <div className="button-price">
              <button className={`btn-comprar `} onClick={this.purchasePlan}>
                Comprar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    plans: state.search.plans,
    userDetails: state.coverage.userDetails,
  }),
  { openModalQuotationDateWarning }
)(withRouter(BottomBar));



// WEBPACK FOOTER //
// ./src/components/coverage/bottom_bar/BottomBar.jsx